/**
 * Formats business size string
 * If businessSizes string contains something other than 'Small Business',
 * remove 'Small Business' text from string
 * @param {string} businessSizes
 * @returns {string} Formatted businessSizes
 */
export const formatBusinessSizes = (businessSizes) => {
  let businessSizesArray = businessSizes.split(",").map((size) => size.trim());
  const omit = businessSizesArray.find((size) => size !== "Small Business");
  if (omit) {
    businessSizesArray = businessSizesArray.filter((size) => size.trim() !== "Small Business");
  }
  const result = businessSizesArray.reduce(
    (resultString, size) => (resultString === "" ? size : resultString + ", " + size),
    ""
  );

  return result;
};

/* eslint-disable no-useless-escape */

/**
 * Prepares text for search by converting to lower case and escaping all regex meta characters
 * @param {string} text
 * @returns {string} converted text
 */
export const prepareTextForSearch = (text) =>
  text.toLowerCase().replaceAll(/[\\\^\$\*\+\?\.\[\]\|\(\)\{\}\-\<\>\=\_]/g, "\\$&");

/**
 * Determines plural or singular form of word based on count
 * @param {string} singularWord
 * @param {number} count
 * @returns {string}
 */
export const formatPlural = (singularWord, count) => (count === 1 ? singularWord : `${singularWord}s`);
